// extracted by mini-css-extract-plugin
export default {"iconButton":"icon-button_iconButton__WpkcG","deleteButton":"icon-button_deleteButton__sWadb","likeButton":"icon-button_likeButton__gr1Ux"};